import actions from './actions'
import mutations from './mutations'

function state () {
  return {
    selectedDayPartNetworks: [],
    networks: [],
    groupings: [],
    userResources: [],
    isRunningResourcePoll: false,
    isGettingUserResources: false,
  }
}

const getters = {
  networkGroupings: state => {
    return state.groupings
  },
  networks: state => {
    return state.networks
  },
  officialNetworks: state => {
    return state.networks ? state.networks.filter(net => net.turner ||
      (net.category.length > 0 && !net.name.includes('('))
    ) : state.networks
  },
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/networks/store/index.js